var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgInboxFill = function SvgInboxFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 19V5q0-.824.587-1.412A1.93 1.93 0 0 1 5 3h14q.824 0 1.413.587Q21 4.176 21 5v14q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21zm7-5q.8 0 1.475-.412.675-.413 1.1-1.088.15-.224.375-.363a.94.94 0 0 1 .5-.137H19V5H5v9h3.55a.94.94 0 0 1 .5.137q.225.138.375.363.425.675 1.1 1.088Q11.2 16 12 16"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInboxFill);
export { ForwardRef as ReactComponent };